import { logDOM } from "@testing-library/react";
import { Axios } from "axios";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { MdVerifiedUser } from "react-icons/md";
import { Navigate } from "react-router-dom";
import { post } from "../../../Server";
import { payAddOption } from "../../../Utils/Apis";
import { renderPrice } from "../../../Utils/functions";
import { useCreateAds } from "../Hooks";


const Accreditation = ({ form }) => {
    const {
        init,
    } = useCreateAds();

    const [radioChecked, setRadioChecked] = useState([])
    const [accepted, setAccepted] = useState(false)
    const [loadingPay, setLoadingPay] = useState(false)

    useEffect(() => {
        if (form?.options?.length > 0) {
            form.options.map(item => {
                if (item.id == 1) setAccepted(true);
            })
        }
    }, [])

    const getOptions = (el, oId, price) => {
        if (el.target.checked) {
            setRadioChecked([...radioChecked, oId])
        }
        else {
            let radioList = radioChecked;
            radioList = radioList.filter(item => {
                return item != oId;
            })
            setRadioChecked(radioList)
        }
    }
    const buyOpions = async () => {
        setLoadingPay(true);
        const { data, status } = await post(
            payAddOption,
            {
                "ads_id": form.id,
                "option": radioChecked
            },
            "در حال انتقال به درگاه بانک"
        );
        
        if (+status == 200) {
            if (data.need_pey === "true") {
                window.location.replace(data.url);
            } else {
                return Navigate("/my-ads");
            }
        }
        setLoadingPay(false);
    };

    return (
        <div className="p-3">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="col-12">
                        <label className="labelinput">انتخاب تنظیمات آگهی</label>
                        <div>
                            <span className="fs-10">نوع قیمت گذاری را انتخاب کنید</span>
                        </div>
                        {init?.options?.map(op => {
                            return (
                                <div className="option mt-2" key={op.id}>
                                    <div>
                                        <MdVerifiedUser color="#0099FF" size={"1.5rem"} />
                                    </div>
                                    <div className="option-content">
                                        <p className="title">{op.title}</p>
                                        <p className="description">{op.description}</p>
                                    </div>
                                    <div className="check-box">
                                        {op.id == 1
                                            ?
                                            accepted
                                                ?
                                                <input type="checkbox" disabled checked />
                                                :
                                                <input
                                                    type="checkbox"
                                                    name={`flexRadioDisabled${op.id}`}
                                                    id={`flexRadioDisabled${op.id}`}
                                                    onChange={(el) => getOptions(el, op.id, op.price)}
                                                />
                                            :
                                            <input
                                                type="checkbox"
                                                name={`flexRadioDisabled${op.id}`}
                                                id={`flexRadioDisabled${op.id}`}
                                                onChange={(el) => getOptions(el, op.id, op.price)}
                                            />
                                        }
                                        <label className="form-check-label" htmlFor={`flexRadioDisabled${op.id}`} >
                                            {renderPrice(op.price)}
                                        </label>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {radioChecked.length > 0 &&
                <div className="row justify-content-end mt-3">
                    <div className="col d-flex justify-content-center">
                        <button className="btn btn-primary w-50" onClick={buyOpions} disabled={loadingPay}>
                            {loadingPay
                                ?
                                "لطفا صبر کنید ..."
                                :
                                "ثبت و پرداخت"
                            }
                        </button>
                    </div>
                </div>
            }
        </div>
    )

}

export default Accreditation;